export { default } from "./memoize.js";